import { render, staticRenderFns } from "./MedicineReports.vue?vue&type=template&id=a3563a96"
import script from "./MedicineReports.vue?vue&type=script&lang=js"
export * from "./MedicineReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports